<template>
  <div ref="ModalSignPDF">
    <el-dialog :visible.sync="isOpen" fullscreen :show-close="false" class="cs-dialog">
      <div v-loading="isLoading || isRendering">
        <div class="cs-sign flex justify-between items-center py-2 px-4 gap-4 mb-4">
          <div class="fs-20 font-bold uppercase text-white">
            {{ getEnvelopeNameByType(documentType) }}
          </div>

          <div class="cs-btn-container">
            <el-dropdown v-if="hasSign && (hasHodoSign || hasVnptSign || hasIntrustSign)">
              <el-button class="fs-16" size="small" plain type="primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path fill="currentColor"
                    d="M12.021 2.772a2.445 2.445 0 1 1 3.458 3.457L14.207 7.5l.086.086a2 2 0 0 1 0 2.829l-1.44 1.439a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-6.646 6.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l8.626-8.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L4.187 12.02l-.925 2.774l2.982-.745l8.527-8.527a1.445 1.445 0 0 0 0-2.043ZM3.217 16.867l.051.038C4.011 17.445 5.112 18 6.5 18c.743 0 1.424-.26 2.029-.604c.603-.344 1.163-.79 1.661-1.195l.117-.095c.464-.378.862-.701 1.228-.917c.403-.238.644-.268.807-.214c.265.088.416.293.679 1.169c.087.292.243.61.471.867c.229.257.569.49 1.008.49c.474 0 .943-.229 1.305-.442c.239-.141.495-.318.703-.46c.103-.07.193-.133.264-.18c.268-.173.494-.285.649-.353c.077-.034.136-.057.174-.07l.04-.014l.006-.002a.5.5 0 0 0-.281-.96h-.001l-.003.002l-.007.002l-.021.007l-.07.023a3.57 3.57 0 0 0-.24.096a5.602 5.602 0 0 0-.79.43c-.117.077-.23.154-.342.232a9.27 9.27 0 0 1-.589.385c-.341.202-.61.303-.797.303c-.06 0-.15-.03-.26-.154a1.34 1.34 0 0 1-.261-.49c-.24-.8-.5-1.556-1.32-1.83c-.588-.196-1.16.023-1.632.301c-.435.257-.892.63-1.337.992l-.13.106c-.502.407-1.004.804-1.526 1.102c-.52.296-1.027.473-1.534.473c-.746 0-1.396-.2-1.934-.47l-1.349.337ZM17.5 15.5l-.14-.48l.14.48Z" />
                </svg>
                {{ $t("Ký") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- HODO Sign -->
                <el-dropdown-item v-if="hasHodoSign" class="py-2">
                  <div @click="handleSignDocument(1)">
                    <svg class="mr-1" width="30" height="30" viewBox="0 0 32 33" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.91091 30.1988L2.52089 22.8088C-0.840297 19.4476 -0.840297 13.9951 2.52089 10.6306L9.91091 3.24062C13.2721 -0.12057 18.7246 -0.12057 22.0891 3.24062L29.4791 10.6306C32.8403 13.9918 32.8403 19.4444 29.4791 22.8088L22.0891 30.1988C18.7246 33.56 13.2754 33.56 9.91091 30.1988Z"
                        fill="#20409B" />
                      <path
                        d="M16.1889 10.7322C16.4802 10.706 16.7584 10.6537 17.0136 10.5719C17.4686 10.4475 17.8678 10.2249 18.1951 9.93038C18.2409 9.89111 18.2868 9.84529 18.3326 9.80274L18.349 9.78638C18.9512 9.18418 19.2817 8.33325 19.2326 7.3514C19.1966 6.61174 18.9282 5.95391 18.4995 5.44335C18.3817 5.29935 18.2508 5.16843 18.1068 5.05061C17.5929 4.6186 16.9351 4.3535 16.1954 4.31422C15.2594 4.2684 14.451 4.56296 13.8554 5.10952C13.8226 5.13897 13.7932 5.16516 13.7637 5.19461C13.3874 5.5579 13.1092 6.02264 12.9652 6.56593C12.9619 6.58229 12.9553 6.59865 12.9521 6.61502C12.8866 6.84739 12.8408 7.09612 12.8179 7.35468C12.8179 7.3874 12.8113 7.42013 12.8081 7.44958C12.4579 11.1806 10.5433 13.1247 6.84499 13.5076C6.7959 13.5141 6.74681 13.5174 6.69772 13.5239C4.81912 13.6941 3.5918 14.9672 3.60162 16.7378C3.60817 17.6542 3.95508 18.4397 4.55074 19.0059C5.11694 19.6016 5.90242 19.9452 6.81553 19.9518C8.58613 19.9648 9.85926 18.7375 10.0294 16.8557C10.0327 16.8033 10.0393 16.7575 10.0458 16.7084C10.4255 13.0068 12.3728 11.0922 16.1038 10.742C16.1267 10.7388 16.1594 10.7355 16.1889 10.7322Z"
                        fill="white" />
                      <path
                        d="M25.3608 19.906C25.6521 19.8799 25.9302 19.8275 26.1855 19.7457C26.6404 19.6213 27.0397 19.3988 27.367 19.1042C27.4128 19.0649 27.4586 19.0191 27.5045 18.9766L27.5208 18.9602C28.123 18.358 28.4536 17.5071 28.4045 16.5252C28.3685 15.7856 28.1001 15.1277 27.6714 14.6172C27.5536 14.4732 27.4226 14.3423 27.2786 14.2244C26.7648 13.7924 26.107 13.5273 25.3673 13.4881C24.4313 13.4422 23.6229 13.7368 23.0273 14.2833C22.9945 14.3128 22.9651 14.339 22.9356 14.3684C22.5592 14.7317 22.281 15.1965 22.137 15.7398C22.1338 15.7561 22.1272 15.7725 22.1239 15.7888C22.0585 16.0212 22.0127 16.2699 21.9898 16.5285C21.9898 16.5612 21.9832 16.594 21.9799 16.6234C21.6298 20.3544 19.7152 22.2985 16.0169 22.6814C15.9678 22.6879 15.9187 22.6912 15.8696 22.6978C13.991 22.868 12.7637 24.1411 12.7735 25.9117C12.78 26.8281 13.127 27.6135 13.7226 28.1797C14.2888 28.7754 15.0743 29.119 15.9874 29.1256C17.758 29.1387 19.0311 27.9114 19.2013 26.0295C19.2046 25.9771 19.2111 25.9313 19.2177 25.8822C19.5973 22.1807 21.5447 20.2661 25.2757 19.9159C25.2986 19.9126 25.328 19.9093 25.3608 19.906Z"
                        fill="white" />
                      <path
                        d="M16.0116 19.9489C17.801 19.9489 19.2517 18.4983 19.2517 16.7088C19.2517 14.9194 17.801 13.4688 16.0116 13.4688C14.2221 13.4688 12.7715 14.9194 12.7715 16.7088C12.7715 18.4983 14.2221 19.9489 16.0116 19.9489Z"
                        fill="white" />
                    </svg>
                    <span class="ml-2">Ký số <strong>HODO</strong></span>
                  </div>
                </el-dropdown-item>
                <!-- VNPT Sign -->
                <el-dropdown-item v-if="hasVnptSign" class="py-2">
                  <div @click="openVNPTCAPopup()">
                    <img width="33" height="32" src="@/assets/images/vnptca.svg" alt="">
                    <span class="ml-2">Ký số <strong>VNPT SmartCA</strong></span>
                  </div>
                </el-dropdown-item>
                <!-- IntrustCA Sign -->
                <el-dropdown-item v-if="hasIntrustSign" class="py-2">
                  <div @click="openIntrustCAPopup()">
                    <img width="33" src="@/assets/images/logo_intrust.png" alt="IntrustCA">
                    <span class="ml-2">Ký số <strong>IntrustCA</strong></span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <SelectSignature v-if="hasSign && (hasHodoSign || hasVnptSign) && !isPatientSign" :signerID="signerID"
              :refreshSignature="refreshSignature" @onChange="handleChangeImageSignature"
              @onOpenModalCreate="openModalCreate" />
            <el-button class="fs-16" size="small" plain type="primary" @click="handleClose">{{ $t("Đóng") }}</el-button>
          </div>
        </div>
        <div class="text-black">
          <div class="p-2 cursor-none cs-container">
            <!-- <input type="text"> -->
            <div :id="containerID" class="pdf-container cs-cursor">
              <div v-for="(signatory, index) in listUserSignatories" :key="index">
                <div v-if="
                  signatory && (signatory.isSelected || signatory.metadata)
                ">
                  <img v-if="signatureImage" class="cs-image-pdf" :id="`${imageID}_${signatory.id}`"
                    :src="signatureImage" alt="Moving Image" :width="imageX" :height="imageY" />
                  <div v-else :id="`${imageID}_${signatory.id}_default`" class="cs-default-signature">
                    <div class="font-bold">{{ $t("Ký") }}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                      <path fill="currentColor"
                        d="M12.021 2.772a2.445 2.445 0 1 1 3.458 3.457L14.207 7.5l.086.086a2 2 0 0 1 0 2.829l-1.44 1.439a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-6.646 6.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l8.626-8.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L4.187 12.02l-.925 2.774l2.982-.745l8.527-8.527a1.445 1.445 0 0 0 0-2.043ZM3.217 16.867l.051.038C4.011 17.445 5.112 18 6.5 18c.743 0 1.424-.26 2.029-.604c.603-.344 1.163-.79 1.661-1.195l.117-.095c.464-.378.862-.701 1.228-.917c.403-.238.644-.268.807-.214c.265.088.416.293.679 1.169c.087.292.243.61.471.867c.229.257.569.49 1.008.49c.474 0 .943-.229 1.305-.442c.239-.141.495-.318.703-.46c.103-.07.193-.133.264-.18c.268-.173.494-.285.649-.353c.077-.034.136-.057.174-.07l.04-.014l.006-.002a.5.5 0 0 0-.281-.96h-.001l-.003.002l-.007.002l-.021.007l-.07.023a3.57 3.57 0 0 0-.24.096a5.602 5.602 0 0 0-.79.43c-.117.077-.23.154-.342.232a9.27 9.27 0 0 1-.589.385c-.341.202-.61.303-.797.303c-.06 0-.15-.03-.26-.154a1.34 1.34 0 0 1-.261-.49c-.24-.8-.5-1.556-1.32-1.83c-.588-.196-1.16.023-1.632.301c-.435.257-.892.63-1.337.992l-.13.106c-.502.407-1.004.804-1.526 1.102c-.52.296-1.027.473-1.534.473c-.746 0-1.396-.2-1.934-.47l-1.349.337ZM17.5 15.5l-.14-.48l.14.48Z" />
                    </svg>
                  </div>
                </div>
              </div>

              <vue-pdf-embed :ref="elementID" :id="elementID" :source="urlPDF"
                @internal-link-clicked="handleClickedPage" @loaded="handleDocumentLoad"
                @rendered="handleDocumentRender" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <ModalCreateSignature ref="ModalCreateSignature" @onSuccess="handleCreateSignatureSuccess" />
    <!-- VNPT Smart CA Popup -->
    <ModalVnptCA ref="ModalVnptCA" @onRequestSign="onVnptRequestSign" />
    <!-- VNPT Smart CA Popup Confirm -->
    <ModalVnptCAConfirm ref="ModalVnptCAConfirm" @onSuccess="handleSignSuccess" />
    <!-- IntrustCA Popup -->
    <ModalIntrustCA ref="ModalIntrustCA" @onRequestSign="onIntrustRequestSign" />
    <!-- IntrustCA Popup Login -->
    <ModalLoginIntrustCA ref="ModalLoginIntrustCA" @onSuccess="handleLoginIntrustCASuccess" />
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import SignatureRequest from '@/api/request/SignatureRequest'
import SelectSignature from './SelectSignature.vue'
import ModalVnptCA from './ModalVnptCA.vue'
import ModalVnptCAConfirm from './ModalVnptCAConfirm.vue'
import ModalIntrustCA from './ModalIntrustCA.vue'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'

import {
  // ENVELOPE_DOCUMENT_TYPE,
  ENVELOPE_TYPE,
  SIGNATORY_ROLE,
  SIGNATORY_STATUS
} from '../../utils/constants'
import uploadS3File from '../../utils/uploadS3File'
import appUtils from '../../utils/appUtils'
import ModalCreateSignature from '../../pages/DoctorSignature/ModalCreateSignature.vue'
import ModalLoginIntrustCA from '../../pages/DoctorSignature/ModalLoginIntrustCA.vue'
import { mixinSignPdf } from '../../utils/mixinSignPdf'

export default {
  name: 'ModalSignPDF',
  components: { VuePdfEmbed, SelectSignature, ModalCreateSignature, ModalVnptCA, ModalVnptCAConfirm, ModalIntrustCA, ModalLoginIntrustCA },
  mixins: [mixinSignPdf, mixinHasFeatures],
  props: {
    elementIDProps: {
      type: String,
      required: true
    },
    containerIDProps: {
      type: String,
      required: true
    },
    imageIDProps: {
      type: String,
      required: true
    },
    envelopeName: {
      type: String
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      pageCount: null,
      signatureImage: '',
      isRendering: true,
      imageX: 80,
      imageY: 40,
      urlPDF: '',
      documentPDFViewer: null,
      documentType: null,
      isUseSignProcedure: false,
      // procedures: [],
      signerID: null,
      documentID: null,
      envelopeSignatories: [],
      selectedSignature: {},
      containerID: 'ContainerPDF',
      elementID: 'SignerPDF',
      imageID: 'ImageID',
      procedureID: null,
      envelopeInfo: null,
      refreshSignature: 0,
      canvasEventHandlers: new Map(),
      listUserSignatories: [],
      isPatientSign: false,
      envelopeId: null,
      selectedVnptCredential: null,
      selectedIntrustData: {
        cert_serial: null,
        pin: null
      }
    }
  },
  computed: {
    request () {
      return new SignatureRequest()
    },
    canSign () {
      const isAllSelectedSignatories = this.listUserSignatories.every(
        (item) =>
          item?.metadata &&
          ((item?.person_id && this.isPatientSign) ||
            item?.user_id === this.$user?.id)
      )
      return isAllSelectedSignatories
    },
    currentSignatory () {
      return this.listUserSignatories?.find((item) => item?.isSelected)
    }
  },
  watch: {
    elementIDProps () {
      this.elementID = this.elementIDProps || 'SignerPDF'
    },
    containerIDProps () {
      this.containerID = this.containerIDProps || 'ContainerPDF'
    },
    imageIDProps () {
      this.imageID = this.imageIDProps || 'imageID'
    }
  },
  created () {
    this.elementID = this.elementIDProps || 'SignerPDF'

    this.containerID = this.containerIDProps || 'ContainerPDF'
    this.imageID = this.imageIDProps || 'imageID'
  },
  mounted () {
    // this.handleCheckMouseInPage()
  },
  methods: {
    handleClose () {
      this.handleClearEvent()

      this.urlPDF = ''
      this.documentPDFViewer = null
      this.envelopeSignatories = []
      this.procedureID = null
      this.signerID = null
      this.documentID = null
      this.documentType = null
      this.isUseSignProcedure = false
      this.envelopeInfo = null
      this.refreshSignature = 0
      this.isOpen = false
      this.listUserSignatories = []
      this.isRendering = false
      this.signatureImage = ''
      this.$emit('onClose')
    },
    handleOpen (
      url,
      docType,
      documentID,
      signerIDProp,
      signatoryProps,
      envelopeInfoProp,
      procedureIDProp,
      isPatientSignProp
    ) {
      this.isRendering = true
      this.urlPDF = url
      this.documentType = docType
      this.documentID = documentID
      this.signerID = signerIDProp
      this.isPatientSign = isPatientSignProp
      this.envelopeInfo = envelopeInfoProp
      this.procedureID = procedureIDProp
      this.isUseSignProcedure = Boolean(procedureIDProp)
      this.envelopeSignatories = signatoryProps || []
      this.canvasEventHandlers = new Map()
      this.handleProcessListUserSignatories(signatoryProps)
      this.isOpen = true
    },
    handleDocumentLoad (documentPDF) {
      this.pageCount = documentPDF.numPages
      this.documentPDFViewer = documentPDF
    },
    handleDocumentRender () {
      if (!this.isRendering) return
      this.handleCheckMouseInPage()
      this.isRendering = false
    },
    handleClickedPage (page) {
      console.log('clicked link', page)
    },
    handleMoveImage (e, container) {
      const self = this

      self.listUserSignatories.forEach((signatory, index) => {
        const imageID = `${self.imageID}_${signatory?.id}`

        const image = document.getElementById(imageID)
        const imageDefault = document.getElementById(`${imageID}_default`)
        if (signatory?.metadata || !signatory?.isSelected) {
          return
        }

        const mouseX = e.clientX - container.getBoundingClientRect().left
        const mouseY = e.clientY - container.getBoundingClientRect().top

        if (image) {
          image.style.left = mouseX + 'px'
          image.style.top = mouseY + 'px'
        }

        if (imageDefault) {
          imageDefault.style.left = mouseX + 'px'
          imageDefault.style.top = mouseY + 'px'
        }
      })
    },
    handleCheckMouseInPage () {
      const container = document.getElementById(this.containerID)
      const canvases = container?.querySelectorAll('canvas')
      const self = this

      const containerHandler = function (e) {
        self.handleMoveImage(e, container)
      }
      container.addEventListener('mousemove', containerHandler)
      self.canvasEventHandlers.set(container, containerHandler)

      canvases.forEach((item, index) => {
        const handler = function (event) {
          if (
            self.currentSignatory?.person_id &&
            self.isPatientSign &&
            !self.signatureImage
          ) {
            self.$refs.ModalCreateSignature.handleOpen(
              self.signerID,
              '',
              self.currentSignatory?.person_id
            )

            return
          }

          self.handleCalcPositionSignature(item, event, index + 1)
        }
        item.addEventListener('mousedown', handler)
        self.canvasEventHandlers.set(item, handler)
      })
    },
    async handleCalcPositionSignature (canvas, event, page) {
      const pageViewer = await this.getPDFPageViewer(page)

      // const pointX = event.offsetX
      // const pointY = event.offsetY
      const imageX = this.imageX
      const imageY = this.imageY

      // Lấy kích thước của canvas
      var rect = canvas.getBoundingClientRect()

      // Tính toán tọa độ x, y của chuột trên canvas
      var x = event.clientX - rect.left
      var y = event.clientY - rect.top

      // Tính toán tọa độ trên PDF từ tọa độ chuột trên canvas
      var viewport = pageViewer.getViewport({ scale: 1.0 })
      var pdfX = (x / rect.width) * viewport.width
      var pdfY = (y / rect.height) * viewport.height
      const pointY = parseInt(viewport.height - pdfY)
      const pointX = pdfX

      const llX = parseInt(pointX - imageX / 2) + 10
      const llY = parseInt(pointY - imageY / 2) + 10
      const urX = parseInt(pointX + imageX / 2) - 5
      const urY = parseInt(pointY + imageY / 2)
      const viewLLY = parseInt(y - this.imageY / 2)
      const viewURY = parseInt(y + this.imageY / 2)
      const viewLLX = parseInt(x - this.imageX / 2)
      const viewURX = parseInt(x + this.imageX / 2)

      if (!this.listUserSignatories?.length) return

      const newSignatories = this.listUserSignatories?.map((signatory) => {
        // Check if the signature is clicked
        const isClickedSignature =
          pointX >= signatory?.metadata?.llX &&
          pointX <= signatory?.metadata?.urX &&
          pointY >= signatory?.metadata?.llY &&
          pointY <= signatory?.metadata?.urY &&
          page === signatory?.metadata?.page
        if (isClickedSignature && signatory.metadata) {
          return { ...signatory, metadata: null, isSelected: true }
        }
        if (!signatory?.metadata && signatory.isSelected) {
          const metadata = {
            llX,
            llY,
            urX,
            urY,
            page,
            viewLLY,
            viewURY,
            viewLLX,
            viewURX,
            pointX: x,
            pointY: y
          }

          return { ...signatory, metadata }
        }

        return { ...signatory }
      })

      this.listUserSignatories = newSignatories

      const nextSignatoryIndex = this.listUserSignatories?.findIndex(
        (itemFilter) => !itemFilter?.metadata
      )

      if (!nextSignatoryIndex || nextSignatoryIndex < 0) return

      this.handleChangeSelectedSignatory(nextSignatoryIndex)

      // Re-render DOM
      this.$forceUpdate()
    },
    handleChangeSelectedSignatory (index) {
      this.listUserSignatories.forEach((signatory, i) => {
        signatory.isSelected = i === index
      })
    },
    // ================================
    // START | POPUP VNPT CA type
    // ================================
    openVNPTCAPopup () {
      this.$refs.ModalVnptCA.handleOpen()
    },
    async handleSignSuccess (signedFileBase64) {
      const [envelopeUrl] = await this.handleUploadFilesAWS(signedFileBase64)

      await this.handleUpdateEnvelopeDocumentURL(
        this.envelopeInfo,
        envelopeUrl
      )

      this.$message({
        type: 'success',
        message: this.$t('Ký tài liệu thành công')
      })

      const responseFormat = 'data:application/pdf;base64,' + signedFileBase64

      this.$emit('onSuccess', responseFormat, this.envelopeInfo)
      this.handleClose()
      this.$refs.ModalVnptCAConfirm.handleClose()
    },
    // ================================
    // END | POPUP VNPT CA type
    // ================================
    // ================================
    // START | POPUP IntrustCA type
    // ================================
    openIntrustCAPopup () {
      this.$refs.ModalIntrustCA.handleOpen()
    },
    async onIntrustRequestSign (signData) {
      this.selectedIntrustData = signData
      this.handleSignDocument(3)
    },
    handleLoginIntrustCASuccess (data) {
      console.log('IntrustCA login success:', data)
      this.$refs.ModalIntrustCA.handleOpen()
    },
    // ================================
    // END | POPUP IntrustCA type
    // ================================
    // Call API ký tài liệu
    async onVnptRequestSign (selectedCredential) {
      this.selectedVnptCredential = selectedCredential
      this.handleSignDocument(2)
    },
    // 1: HODO  2. VNPT SmartCA  3. IntrustCA
    async handleSignDocument (type) {
      try {
        const isValid = this.handleValidateSignDocument()
        if (!isValid) return
        this.isLoading = true
        let responseEnvelope
        let documentBase64

        // Process documentBase64 and Envelope
        if (!this.envelopeInfo) {
          const { envelopeUrl, documentBase64Data } =
            await this.handleProcessDocument()
          if (!envelopeUrl || !documentBase64Data) return

          documentBase64 = documentBase64Data
          responseEnvelope = await this.handleCreateEnvelope(envelopeUrl)

          if (!responseEnvelope || !responseEnvelope?.id) {
            this.$message({
              type: 'error',
              message: this.$t('Ký tài liệu thất bại')
            })
            return
          }
          this.envelopeInfo = responseEnvelope
        } else {
          await this.handleUpdateSignatoryMetadata()

          responseEnvelope = this.envelopeInfo
          documentBase64 = await this.getFileAsBase64(this.urlPDF)

          if (!documentBase64) return
        }

        const isValidSigningRule =
          this.handleValidateSigningRule(responseEnvelope)

        if (!isValidSigningRule) return

        const params = this.listUserSignatories?.map((item) => {
          const responseSignatory =
            responseEnvelope?.envelope_signatories?.find((itemFind) => {
              if (item?.node_signatory_id) {
                return itemFind?.node_signatory_id === item?.node_signatory_id
              } else {
                return itemFind?.node_signatory_id === item?.id
              }
            })

          return {
            workername: this.selectedSignature?.signature_name,
            envelope_id: responseEnvelope.id,
            signatory_id: responseSignatory?.id,
            document_base64: documentBase64
          }
        })

        switch (type) {
          case 1:
            // HODO
            const dodoSignResponse = await this.request.signingDocumentWithSignatories({
              list_data: params
            })

            if (dodoSignResponse.status === 200) {
              const [envelopeUrl] = await this.handleUploadFilesAWS(dodoSignResponse.data)

              await this.handleUpdateEnvelopeDocumentURL(
                responseEnvelope,
                envelopeUrl
              )

              this.$message({
                type: 'success',
                message: this.$t('Ký tài liệu thành công')
              })

              const responseFormat = 'data:application/pdf;base64,' + dodoSignResponse.data

              this.$emit('onSuccess', responseFormat, responseEnvelope)
              this.handleClose()
            }
            break
          case 2:
            // VNPT SmartCA
            // Request body for signing
            const vnptSignBody = {
              list_data: [
                {
                  workername: params[0].workername,
                  envelope_id: params[0].envelope_id,
                  signatory_id: params[0].signatory_id,
                  document_base64: params[0].document_base64,
                  serial_number: this.selectedVnptCredential.serial_number,
                  cccd: this.$user.doctor.national_id // CCCD
                }
              ]
            }

            const vnptSignResponse = await this.request.vnptRequestSign(vnptSignBody)
            this.$refs.ModalVnptCAConfirm.handleOpen(vnptSignBody, vnptSignResponse.data.data.transaction_id, this.selectedVnptCredential)
            break
          case 3:
            // IntrustCA
            console.log('responseEnvelope', responseEnvelope, this.selectedSignature)

            const intrustSignBody = {
              document_base64: params[0].document_base64,
              worker_name: this.selectedSignature?.signature_name,
              pin_code: this.selectedIntrustData.pin,
              cert_serial: this.selectedIntrustData.cert_serial,
              envelope_id: responseEnvelope.id,
              file_name: `${this.getEnvelopeNameByType(responseEnvelope.document_type)}-${responseEnvelope.envelope_name}`,
              list_position_coordinate: []
            }
            // Get signature positions for the current user
            responseEnvelope.envelope_signatories.forEach((item) => {
              if (item.user_id == this.$user?.id) {
                intrustSignBody.list_position_coordinate.push({
                  page: item.signatory_metadata.signature_position_page,
                  coorDinate: item.signatory_metadata.signature_position_rectangle_pdf
                })
              }
            })

            this.isLoading = true
            const intrustSignResponse = await this.request.intrustSign(intrustSignBody)

            if (intrustSignResponse.status === 200) {
              if (intrustSignResponse.data.code === 0) {
                // Successful signing
                // Handle successful signing
                const signedFileBase64 = intrustSignResponse.data.data.content_file
                const [envelopeUrl] = await this.handleUploadFilesAWS(signedFileBase64)

                await this.handleUpdateEnvelopeDocumentURL(
                  responseEnvelope,
                  envelopeUrl
                )

                this.$message({
                  type: 'success',
                  message: this.$t('Ký tài liệu thành công')
                })

                const responseFormat = 'data:application/pdf;base64,' + signedFileBase64

                this.$emit('onSuccess', responseFormat, responseEnvelope)
                this.handleClose()
              } else if (intrustSignResponse.data.code === 997) {
                // Call API login with refresh token then retry sign document
                const loginWithRefreshTokenResponse = await this.request.loginIntrustCAWithRefreshToken()
                if (loginWithRefreshTokenResponse.status === 200 && loginWithRefreshTokenResponse.data.success === true) {
                  // Retry sign document
                  this.handleSignDocument(3)
                } else {
                  // Open popup login IntrustCA
                  this.$refs.ModalLoginIntrustCA.handleOpen()
                }
                return
              } else if (intrustSignResponse.data.code === 5) {
                // Open popup login IntrustCA
                this.$refs.ModalLoginIntrustCA.handleOpen()
                return
              } else if (intrustSignResponse.data.code === 498) {
                // Handle wrong PIN code
                this.$message({
                  type: 'error',
                  message: this.$t('Mã PIN không đúng. Vui lòng thử lại.')
                })
                // Open popup select certificate and type PIN code again
                setTimeout(() => {
                  this.$refs.ModalIntrustCA.handleOpen()
                }, 3000)
                return
              } else {
                // Check current auth method
                if (this.selectedIntrustData.auth_method === 1) {
                  // Call API register session
                  const registerSessionResponse = await this.request.registerSessionIntrustCAAccount({
                    credential_id: this.selectedIntrustData.key_id
                  })

                  if (registerSessionResponse.status === 200 && registerSessionResponse.data.success === true) {
                    // Retry sign document
                    this.handleSignDocument(3)
                  } else {
                    this.$message({
                      type: 'error',
                      message: this.$t('Ký tài liệu thất bại')
                    })
                    return
                  }
                }
              }
            }
            break
          default:
            break
        }
      } catch (error) {
        console.log(error)
        this.$message({
          type: 'error',
          message: error.response?.data?.message || this.$t('Ký tài liệu thất bại')
        })
      } finally {
        this.isLoading = false
      }
    },
    async getPDFPageViewer (pageNum) {
      const pageViewer = await this.documentPDFViewer.getPage(pageNum)
      return pageViewer
    },
    handleChangeImageSignature (data) {
      const base64 = data.signature_base64
      this.signatureImage = this.generateImageSrcBase64(base64)

      this.canvasSelectedClicked = false
      this.selectedSignature = data
    },
    generateImageSrcBase64 (content) {
      var prefix = 'data:image/png;base64,'

      return prefix + content
    },
    async handleCreateEnvelope (envelopeUrl) {
      try {
        const signatories = this.handleProcessEnvelopSignatories()
        const params = {
          sign_procedure_id: this.procedureID,
          document_id: this.documentID,
          document_type: this.documentType,
          envelope_name:
            this.envelopeName || this.getEnvelopeNameByType(this.documentType),
          document_url: envelopeUrl,
          envelope_description: '',
          envelope_type: ENVELOPE_TYPE.SELF_SIGN,
          issuer: this.$user?.id,
          issuer_date: window.moment().valueOf(),
          envelope_signatories: signatories
        }

        const response = await this.request.createEnvelope(params)

        if (response.status === 200) {
          return response.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleProcessDocument () {
      try {
        const newImageSrc = new URLSearchParams(this.urlPDF).toString()
        const formatImageSrc = newImageSrc.substring(0, newImageSrc.length - 1)
        const responseImage = await this.$rf
          .getRequest('DoctorRequest')
          .postUrlImage(formatImageSrc)
        const base64File = responseImage.data?.data || ''

        const [envelopeUrl] = await this.handleUploadFilesAWS(base64File)

        return { envelopeUrl, documentBase64Data: base64File }

        // return base64File
      } catch (error) {
        console.log(error)
      }
    },
    handleValidateSignDocument () {
      if (!this.urlPDF) return

      if (!this.selectedSignature?.signature_name || !this.signatureImage) {
        this.$message({
          type: 'error',
          message: this.$t('Không tìm thấy thông tin chữ ký')
        })
        return
      }

      if (!this.canSign) {
        const isAllSelectedSignatories = this.listUserSignatories.every(
          (item) => item?.metadata
        )

        if (!isAllSelectedSignatories) {
          this.$message({
            type: 'error',
            message: this.$t('Vui lòng chọn vị trí cho tất cả chữ ký')
          })

          return
        }

        this.$message({
          type: 'error',
          message: this.$t('Bạn không có quyền ký tài liệu')
        })

        return
      }

      return true
    },

    handleProcessEnvelopSignatories () {
      if (this.isUseSignProcedure) {
        const signatories = this.envelopeSignatories?.map((item) => {
          const metadata = this.listUserSignatories?.find(
            (itemFind) => itemFind?.id === item?.id
          )?.metadata

          const llX = metadata?.llX
          const llY = metadata?.llY
          const urX = metadata?.urX
          const urY = metadata?.urY
          const page = metadata?.page
          const viewllX = metadata?.viewLLX
          const viewllY = metadata?.viewLLY
          const viewurX = metadata?.viewURX
          const viewurY = metadata?.viewURY

          if (
            (this.signerID && item?.user_id === this.signerID) ||
            (item?.person_id && this.isPatientSign)
          ) {
            return {
              // ...item,
              node_signatory_id: item?.id,
              user_id: item?.user_id,
              person_id: item?.person_id,
              signatory_name: item?.user?.name,
              signatory_email: item?.user?.email,
              signatory_role: SIGNATORY_ROLE.signer,
              signatory_order: item?.sign_order,
              role_name: item?.role_name,
              is_required: item?.is_required,
              expired_date: item?.expired_date || undefined,
              metadata: {
                signature_id: this.selectedSignature.id,
                signature_position_rectangle: [
                  viewllX,
                  viewllY,
                  viewurX,
                  viewurY
                ].join(','),
                signature_position_rectangle_pdf: [llX, llY, urX, urY].join(
                  ','
                ),
                signature_position_page: String(page)
              }
            }
          } else {
            return {
              // ...item,
              node_signatory_id: item?.id,
              user_id: item?.user_id,
              person_id: item?.person_id,
              signatory_name: item?.user?.name,
              signatory_email: item?.user?.email,
              signatory_role: SIGNATORY_ROLE.signer,
              signatory_order: item?.sign_order,
              role_name: item?.role_name,
              is_required: item?.is_required,
              expired_date: item?.expired_date || undefined
            }
          }
        })

        return signatories
      } else {
        // TODO: manual
        return []
      }
    },
    handleCreateSignatureSuccess (data) {
      const self = this
      self.signatureImage = self.generateImageSrcBase64(data.signature_base64)
      self.selectedSignature = data
      // self.canvasSelectedClicked = true
      self.$nextTick(() => {
        const image = document.getElementById(self.imageID)
        image.style.left = self.metadata.pointX + 'px'
        image.style.top = self.metadata.pointY + 'px'
        // self.handleCheckMouseInPage()
      })

      this.refreshSignature++

      // console.log(data)
    },
    async handleUploadFilesAWS (base64) {
      if (!this.documentID) return

      const formatBase64 = 'data:application/pdf;base64,' + base64

      const file = appUtils.convertBase64tToFile(
        formatBase64,
        this.getEnvelopeNameByType(this.documentType)
      )

      const prefixPath = `resources/sign_envelopes/${this.documentType}/`

      const resultUrl = await uploadS3File.uploadHandler(
        this.documentID,
        window.moment().valueOf(),
        [file],
        1,
        prefixPath
      )

      return resultUrl?.map((item) => item?.url)
    },
    async handleUpdateEnvelopeDocumentURL (responseEnvelope, url) {
      if (!responseEnvelope?.id) return

      try {
        const request = new SignatureRequest()

        await request.updateEnvelope(responseEnvelope.id, {
          document_url: url
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getFileAsBase64 (url) {
      try {
        // Fetch the file from the URL
        const response = await fetch(url)

        // Ensure the response is ok
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }

        // Get the Blob from the response
        const blob = await response.blob()

        // Convert the Blob to a Base64 string
        const base64String = await this.blobToBase64(blob)
        const base64 = this.removePrefixDocument(base64String)

        return base64
      } catch (error) {
        console.error('Error fetching or converting the file:', error)
      }
    },

    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    removePrefixDocument (base64) {
      let prefix = 'data:application/pdf;base64,'
      if (base64.startsWith(prefix)) {
        return base64.slice(prefix.length)
      }
      return base64
    },
    async handleUpdateSignatoryMetadata () {
      try {
        const signatoriesMetadata = this.listUserSignatories?.map(
          (signatoryData) => {
            const signatory = this.envelopeSignatories?.find(
              (itemFind) => itemFind?.id === signatoryData?.id
            )
            const llX = signatoryData?.metadata?.llX
            const llY = signatoryData?.metadata?.llY
            const urX = signatoryData?.metadata?.urX
            const urY = signatoryData?.metadata?.urY
            const page = signatoryData?.metadata?.page
            const viewllX = signatoryData?.metadata?.viewLLX
            const viewllY = signatoryData?.metadata?.viewLLY
            const viewurX = signatoryData?.metadata?.viewURX
            const viewurY = signatoryData?.metadata?.viewURY

            return {
              signatory_metadata_id: signatory?.signatory_metadata?.id,
              signature_id: this.selectedSignature.id,
              signature_position_rectangle: [
                viewllX,
                viewllY,
                viewurX,
                viewurY
              ].join(','),
              signature_position_rectangle_pdf: [llX, llY, urX, urY].join(','),
              signature_position_page: String(page)
            }
          }
        )

        var response = await this.request.updateListSignatoryMetadata({
          list_data: signatoriesMetadata
        })

        if (response.status === 200) {
          return response.data
        } else {
          return null
        }

        // const signatoryMetadata = this.currentSignatory?.signatory_metadata
        // if (!signatoryMetadata?.id) return

        // const llX = this.metadata?.llX
        // const llY = this.metadata?.llY
        // const urX = this.metadata?.urX
        // const urY = this.metadata?.urY
        // const page = this.metadata?.page
        // const viewllX = this.metadata?.viewLLX
        // const viewllY = this.metadata?.viewLLY
        // const viewurX = this.metadata?.viewURX
        // const viewurY = this.metadata?.viewURY
        // const params = {
        //   signature_id: this.selectedSignature.id,
        //   signature_position_rectangle: [
        //     viewllX,
        //     viewllY,
        //     viewurX,
        //     viewurY
        //   ].join(','),
        //   signature_position_rectangle_pdf: [llX, llY, urX, urY].join(','),
        //   signature_position_page: String(page)
        // }
      } catch (error) {
        console.log(error)
      }
    },
    openModalCreate () {
      this.$refs.ModalCreateSignature.handleOpen(this.signerID)
    },
    handleCreateSuccess (signature) {
      this.refreshSignature++
      this.selectedSignature = signature
    },
    handleValidateSigningRule (responseEnvelope) {
      // Check permission signatory
      const hasPermissionSignatory = this.envelopeSignatories?.some(
        (item) =>
          item?.user_id === this.$user?.id || item?.user_role == 'patient'
      )

      if (!hasPermissionSignatory) {
        this.$toast.open({
          type: 'error',
          message: 'Bạn không có quyền ký tài liệu này'
        })
        return
      }

      // Validate signed
      // const hasSignedEnvelope =
      //   this.currentSignatory?.status === SIGNATORY_STATUS.signed
      // if (hasSignedEnvelope) {
      //   this.$toast.open({
      //     type: 'warning',
      //     message: 'Bạn đã ký tài liệu này'
      //   })
      //   return
      // }

      // Validate signatory_order
      const isValidSignOrder = responseEnvelope?.envelope_signatories
        ?.filter(
          (item) =>
            item?.signatory_order <
            (this.currentSignatory?.signatory_order ||
              this.currentSignatory?.sign_order) &&
            item?.node_signatory_info?.sign_node_id ===
            this.currentSignatory?.node_signatory_info?.sign_node_id
        )
        .every((item) => item?.status === SIGNATORY_STATUS.signed)

      if (!isValidSignOrder) {
        this.$toast.open({
          type: 'error',
          message: 'Bạn phải ký theo thứ tự! Vui lòng chờ đến lượt ký của bạn'
        })

        return
      }

      return true
    },
    handleClearEvent () {
      const self = this
      const container = document.getElementById(this.containerID)
      const canvases = container?.querySelectorAll('canvas')

      if (self.canvasEventHandlers) {
        const containerHandler = self.canvasEventHandlers.get(container)
        if (containerHandler) {
          container.removeEventListener('mousemove', containerHandler)
          self.canvasEventHandlers.delete(container)
        }

        canvases.forEach((item) => {
          const handler = self.canvasEventHandlers.get(item)
          if (handler) {
            item.removeEventListener('mousedown', handler)
            self.canvasEventHandlers.delete(item)
          }
        })
      }
    },
    handleProcessListUserSignatories (signatories) {
      const newSignatories = signatories?.reduce((arr, item) => {
        if (
          (item?.user_id === this.$user?.id &&
            item.status !== SIGNATORY_STATUS.signed &&
            !this.isPatientSign) ||
          (item?.person_id && this.isPatientSign)
        ) {
          if (arr?.length === 0) {
            arr.push({ ...item, isSelected: true })
          } else {
            // Chỉ lấy những signatory cùng user_id và cùng sign order
            const isEqualSignOrder = arr.every((childItem) => {
              const childOrder =
                childItem?.sign_order || childItem?.signatory_order
              const itemOrder = item?.signatory_order || item?.sign_order

              return childOrder && itemOrder && childOrder === itemOrder
            })
            if (isEqualSignOrder) {
              arr.push(item)
            }
          }
        }

        return arr
      }, [])

      this.listUserSignatories = newSignatories
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-pdf-embed {
  margin: 0 auto;
}

.vue-pdf-embed__page {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.cs-container {
  overflow: auto;
  // pointer-events: none;
}

.pdf-container {
  width: 1000px;
  border: 1px solid #000;
  margin: 0 auto;
  position: relative;
}

::v-deep {
  .vue-pdf-embed {
    .vue-pdf-embed__page {
      box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .cs-dialog {
    .el-dialog__header {
      padding: 0 !important;
    }

    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.cs-image-pdf {
  position: absolute;
  z-index: 1000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  border: 1px dashed #696969;
  padding: 4px;
}

.cs-sign {
  position: sticky;
  top: 0px;
  right: 20px;
  background-color: rgb(74, 74, 74);
  z-index: 100000;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 8px 16px;
}

.cs-default-signature {
  position: absolute;
  z-index: 1000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  border: 1px dashed #696969;
  padding: 4px;
  width: 80px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffc820;
}

.cs-btn-container {
  display: flex;
  gap: 8px;
}
</style>
